export default {
    "lightMetricsVideo_error": "Error al obtener el video, por favor intente de nuevo.",
    "lightMetricsVideo_liveNotAvailable": "Ya hay una sesión de streaming activa en el dispositivo, por favor intente de nuevo más tarde.",
    "lightMetricsVideo_liveNotAvailable_ignitionOff": "El vehículo está actualmente fuera de línea - no se puede transmitir en vivo",
    "lightMetricsVideo_joiningExistingSession": "Uniéndose a una sesión en vivo ya activa",
}